import {registerTemplateGraphNode} from "#template/template-node/register"
import {pointGeometryAttributeSetLike, pointGeometryAttributeSetLikeMarker} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"
import {pointGeometryAttributeLike} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {PointGeometryAttributeLikeNode} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {PointGeometryAttributeSetLikeNode} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"

import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

import type {PartitionOperatorParameters} from "#template/nodes/geometry-graph/attribute-set/partition-operator/geometry-partition-operator-node"
import {
    GeometryPartitionOperatorNode,
    partitionOperatorParametersSchema,
} from "#template/nodes/geometry-graph/attribute-set/partition-operator/geometry-partition-operator-node"

export type PointGeometryPartitionOperatorParameters = PartitionOperatorParameters<PointGeometryAttributeLikeNode, PointGeometryAttributeSetLikeNode>

const definition: TemplateNodeDefinition<PointGeometryPartitionOperatorParameters> = {
    nodeClass: "PointGeometryPartitionOperator",
    validation: {
        parameters: partitionOperatorParametersSchema(pointGeometryAttributeLike, pointGeometryAttributeSetLike),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class PointGeometryPartitionOperator
    extends GeometryPartitionOperatorNode<0, PointGeometryAttributeLikeNode, PointGeometryAttributeSetLikeNode>
    implements PointGeometryAttributeSetLikeNode
{
    get [pointGeometryAttributeSetLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }
}
